import { render, staticRenderFns } from "./AdminOrdersList.vue?vue&type=template&id=404c5f90&scoped=true"
import script from "./AdminOrdersList.vue?vue&type=script&lang=js"
export * from "./AdminOrdersList.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersList.vue?vue&type=style&index=0&id=404c5f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404c5f90",
  null
  
)

export default component.exports